import { render, staticRenderFns } from "./tripManage.vue?vue&type=template&id=045d8cc4&scoped=true"
import script from "./tripManage.vue?vue&type=script&lang=js"
export * from "./tripManage.vue?vue&type=script&lang=js"
import style0 from "./tripManage.vue?vue&type=style&index=0&id=045d8cc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045d8cc4",
  null
  
)

export default component.exports